<template lang="pug">
  .language-member
    .lucky-area
      .lucky-machine
        ul(ref="luckyMachineContent")
          li(v-for="(item, index) in [0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0]", :key="index")
            .lucky-card(v-for="(card, cIndex) in [1, 1, 1]", :key="cIndex")
              img(v-if="item === 1", src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/language/red-vip.png?x-oss-process=style/414_jpeg_zoom")
              img(v-else, src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/language/red-lucky.png?x-oss-process=style/414_jpeg_zoom")
      .lucky-btn
        img(src="../../../public/images/member/red-lucky-btn.png")
      .lucky-lefttime 
        |距离本场结束时间：
        span {{time.m}}
        | :
        span {{time.s}}
        | :
        span {{time.ms}}
      .lucky-numbers
        ul
          li(v-for="item in numberPool", :key="item")
            | {{item}} 获得
            span 视频会员，20元话费
    .lucky-form-dialog(v-show="formVisible")
      .lucky-form-dialog-content
        .lucky-rights
          img(src="../../../public/images/member/red-videoicons.png")
        .lucky-form
          input(type="text", v-model="form.mobile", placeholder="请输入手机号")
          .btn-submit(@click="handleSubmit")  
    .btn-notice(@click="noticeVisible = true") 活动规则
    el-dialog(:visible.sync="noticeVisible", title="- 活动规则 -", width="96%")
      .notice-content
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      noticeVisible: false,
      formVisible: false,
      time: {
        m: '03',
        s: '00',
        ms: '00'
      },
      maxLeftTime: 3 * 60 * 1000,
      notices: [
        '会员费用：19元/月',
        '赠送12个月视频会员，从办理起立即生效，为期12个月，当月会员限当月使用，过期作废。视频会员领取后，有效期自领取日起30天，当月不可更改已兑换成功的会员。',
        '权益说明：客户签约成功并支付会员月费，即可享30元话费券、外卖红包、陀螺好物、爱奇艺会员1折起、移动花卡免费领取的会员专属特权。',
        '权益领取：以上6款会员权益均可通过微信搜索关注“language会员”公众号，在会员权益中通过支付关联的手机号码领取，会员生效期间，30元话费券、视频会员每月均可领取，其余4款会员特权一直可领取。',
        '30元话费券为6张*5元话费减免券，可在“language会员”公众号充值100元话费时直接使用，即仅需支付95元即可获得100元话费。',
        '陀螺好物即百种商品免费领权益，可跳转至微信小程序“陀螺好物”中按页面说明完成相应任务即可免费领取百种商品。',
        '爱奇艺会员最低1元购买权益：最低支付1元购买爱奇艺月度会员。',
        '外卖红包权益：每天可通过“language会员”公众号，领取最高56元的美团外卖红包。',
        '注意事项：请在购买时务必填写正确的需充值的手机号码及短信验证码，本产品为系统自动办理，人工无法手动取消办理或者退款，敬请谅解。',
      ],
      numberPool: ['132****1807', '137****2033', '134****3944', '158****4323', '186****2520', '182****5446'],
      form: {
        mobile: '',
        goodsCode: 'WXPAPAY210226002'
      },
      payUrl: '',
      channel: 'TUIA'
    }
  },
  mounted() {
    setTimeout(() => {
      this.luckyMachineAnimation()
    }, 600)
    let _now = new Date()
    let _month = _now.getMonth() + 1
    let _day = _now.getDay()
    this.date = `${_now.getFullYear()}.${_month < 10 ? '0' + _month : _month}.${_day < 10 ? '0' + _day : _day}`
    this.costLeftTime()
    this.form.mobile = localStorage.getItem('language-member-mobile') || ''
    this.reqNo = localStorage.getItem('language-member-req-no')
    if (this.reqNo) {
      localStorage.removeItem('language-member-req-no')
      this.confirmPay()
    }
  },
  methods: {
    costLeftTime() {
      if (this.maxLeftTime > 20) {
        this.maxLeftTime = this.maxLeftTime - 20
        let _m = Math.floor(this.maxLeftTime / (60 * 1000))
        let _s = Math.floor((this.maxLeftTime - _m * 60 * 1000) / 1000)
        let _ms = this.maxLeftTime % 1000
        this.time.m = '0' + _m
        this.time.s = _s < 10 ? '0' + _s : _s
        if (_ms > 100) {
          this.time.ms = _ms.toString().substr(0, 2)
        } else if(_ms < 10) {
          this.time.ms = '0' + _ms
        } else {
          this.time.ms = _ms
        }
        setTimeout(() => {
          this.costLeftTime()
        }, 20)
      } else {
        this.time.m = '00'
        this.time.s = '00'
        this.time.ms = '00'
      }
    },
    luckyMachineAnimation() {
      this.$refs.luckyMachineContent.style.marginTop = `-100vw`
      setTimeout(() => {
        this.formVisible = true
      }, 2500)
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile ? this.form.mobile.trim() : ''
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.addMobilePackage()
    },
    addMobilePackage() {
      // eslint-disable-next-line
      let _queryStr = location.search.replace(/^\?/, '') + location.hash.replace(/^\#/, '&')
      let _oid = ''
      if (_queryStr) {
        let _querys = _queryStr.split('&')
        _querys.forEach(item => {
          // eslint-disable-next-line
          if (/^a\_oId\=/.test(item)) {
            _oid = item.split('=')[1]
          }
        })
      }
      // 此处不用等待支付，直接记录转化，后端会确认支付状态后进行转化数据推送
      if (window.countLog) {
        window.countLog.ready(function() {
          window.countLog.init(function() { 
          }, {
            isCopy: 0,
            pageType: 0 
          })
        })
      }
      // this.$router.push({
      //   name: 'lanRedConfirmOrder'
      // })
      let _formData = {
        mobile: this.form.mobile,
        goodsCode: this.form.goodsCode,
        channel: this.channel,
        channelOrderNo: _oid
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在提交...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .createActPayOrder(_formData)
        .then(res => {
          if (res.data.success) {
            this.reqNo = res.data.sub_data.req_no
            localStorage.setItem('language-member-req-no', res.data.sub_data.req_no)
            localStorage.setItem('language-member-mobile', this.form.mobile)
            this.$loading({
              lock: true,
              text: '正在确认中，请稍后...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            location.href = res.data.sub_data.pay_url
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
            if (res.data.result_code == '1') {
              location.href = 'https://mp.weixin.qq.com/s?__biz=MzU0NjkwNjU1Mw==&mid=100000052&idx=1&sn=b6ce9ce71f15c9c5312a1f41e3c644f4&chksm=7b57c9e24c2040f43493d171c6a086b084726925abc4b0b01adfdae2e15d40cc7408a4b1f6b1#rd'
            }
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    confirmPay() {
      let _loading = this.$loading({
        lock: true,
        text: '正在确认签约状态...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .queryPayOrder({
          reqNo: this.reqNo,
          mobile: this.form.mobile
        })
        .then(res => {
          if (res.data.success) {
            if (res.data.sub_data.trade_state.toUpperCase() === 'SUCCESS') {
              this.$message({
                type: 'success',
                message: '签约成功，正在前往Language会员公众号'
              })
              location.href = 'https://mp.weixin.qq.com/s?__biz=MzU0NjkwNjU1Mw==&mid=100000052&idx=1&sn=b6ce9ce71f15c9c5312a1f41e3c644f4&chksm=7b57c9e24c2040f43493d171c6a086b084726925abc4b0b01adfdae2e15d40cc7408a4b1f6b1#rd'
            } else {
              this.$message({
                type: 'warning',
                message: res.data.sub_data.trade_state_desc
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '查询失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.language-member{
  background-color: #f13829;
  background-image: url('https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/language/red-bg.png?x-oss-process=style/414_jpeg_zoom');
  background-size: 100%;
  background-repeat: no-repeat;
  height: 100vh;
  overflow: hidden;
}
.btn-notice{
  position: absolute;
  right: 0;
  top: 2rem;
  word-wrap: break-word;
  width: 1rem;
  font-size: 1rem;
  color: #f3f3f3;
  background-color: rgba(33, 33, 33, .4);
  padding: .5rem;
}
.lucky-area{
  padding-top: 72.2vw;
  .lucky-btn{
    margin-top: 15.8vw;
    text-align: center;
    img{
      width: 70%;
    }
  }
  .lucky-machine{
    width: 60%;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    height: 46vw;
    ul{
      margin-top: 0;
      transition: margin-top 2s;
      li{
        display: flex;
        margin-top: 1rem;
        .lucky-card{
          flex: 1;
          text-align: center;
          img{
            width: 56%;
          }
        }
      }
    }
  }
  .lucky-lefttime{
    margin-top: 2.4vw;
    text-align: center;
    color: #ffc6a9;
    font-size: .8rem;
  }
  .lucky-numbers{
    margin-top: 8vw;
    text-align: center;
    color: #ffc6a9;
    font-size: .8rem;
    span{
      color: #ffe160;
    }
  }
}
.lucky-form-dialog{
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 33, 33, .5);
  top: 0;
  left: 0;
  .lucky-form-dialog-content{
    background-image: url('https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/language/red-form-bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 70vw;
    margin: 0 auto;
    margin-top: 30vw;
    height: 110vw;
    padding-top: 18%;
    .lucky-rights{
      width: 66%;
      margin: 0 auto;
      img{
        width: 100%;
      }
    }
    .lucky-form{
      margin-top: 34%;
      text-align: center;
      input{
        border-radius: 24px;
        font-size: 1.2rem;
        text-align: center;
        padding: .6rem 0;
        border: 0;
        width: 90%;
      }
      .btn-submit{
        background-image: url('https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/language/red-form-btn.png');
        background-size: 100%;
        background-repeat: no-repeat;
        width: 90%;
        margin: 0 auto;
        margin-top: 1rem;
        height: 3rem;
        font-size: 1.2rem;
      }
    }
  }
}
.notice-content{
  font-size: .8rem;
  ul{
    li{
      display: flex;
      .num{
        flex-basis: 1rem;
      }
    }
  }
}
</style>